module.exports = "//public.getcloudapp.com/packs/media/images/parallax-76a24924bc1536861f9252b98e4e8130.jpg";